import React from 'react';
import { Card, CardContent } from '@lb-service/ui';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import SectionIntro from '../../../molecules/SectionIntro';

const PricingFaqs = () => {
  const { t } = useTranslation('common');
  return (
    <div className="pricing-faqs">
      <Card className="bg-slate-50 border-0 shadow-none rounded-none">
        <CardContent>
          <div id="pricing-faq-container" className="mb-24">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
              <SectionIntro title={t('service.pricing.faq.title')} />
              <div className="grid grid-cols-12 gap-4 mt-16">
                <div className="lg:col-span-6 md:col-span-6 col-span-12">
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.leftQ1')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.leftA1')}
                    </dd>
                  </dl>
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.leftQ2')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.leftA2')}
                    </dd>
                  </dl>
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.leftQ3')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.leftA3')}
                    </dd>
                  </dl>
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.leftQ4')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.leftA4')}
                    </dd>
                  </dl>
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.leftQ5')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.leftA5both')}
                    </dd>
                  </dl>
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.leftQ6')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.leftA6')}
                    </dd>
                  </dl>
                </div>
                <div className="lg:col-span-6 md:col-span-6 col-span-12">
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.rightQ1')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.rightA1')}
                    </dd>
                  </dl>
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.rightQ2')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.rightA2')}
                    </dd>
                  </dl>
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.rightQ3')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.rightA3Stripe')}
                    </dd>
                  </dl>
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.rightQ4')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.rightA4')}
                    </dd>
                  </dl>
                  <dl className="mb-8">
                    <dt className="mb-4">{t('service.pricing.faq.rightQ5')}</dt>
                    <dd className="text-muted">
                      {t('service.pricing.faq.rightA5')}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default PricingFaqs;
